import { useEffect, useState } from "react";

export function useInView(ref, { rootMargin = "300px", threshold = 0.01 } = {}) {
    const [inView, setInView] = useState(false);

    useEffect(() => {
        const el = ref.current;
        if (!el) return;

        if (!("IntersectionObserver" in window)) {
            setInView(true);
            return;
        }

        const obs = new IntersectionObserver(([entry]) => {
            if (entry.isIntersecting) {
                setInView(true);
                obs.disconnect();
            }
        }, { rootMargin, threshold });

        obs.observe(el);
        return () => obs.disconnect();
    }, [ref, rootMargin, threshold]);

    return inView;
}
